import Coba from "./Coba";

export default Coba;
